export class FragmentDataExporter {
  constructor(keys) {
    this.keys = keys;
  }
  export(props) {
    const exportData = this.getDefaultExportData();
    const layersData = props.state.scene.layers;
    for (const [layerName, layer] of layersData) {
      this.saveFloorProperties(exportData, layer);
      this.saveAllItemsProperties(layer, exportData, layerName);
    }
    return exportData;
  }

  saveAllItemsProperties(layer, exportData, layerName) {
    for (const key of this.keys) {
      for (const [itemID, item] of layer[key]) {
        const type = exportData.allTypes[item.type];
        if (!type) {
          console.log(`Element ${itemID} can't be exported`);
          continue;
        }
        this.saveItemData(exportData, itemID, item, type, layerName);
      }
    }
  }

  saveItemData(exportData, itemID, item, type, layerName) {
    exportData.modelTypes[itemID] = item.type;
    exportData.properties[itemID] = { expressID: itemID, type };
    exportData.levelsRelationships[itemID] = layerName;
  }

  saveFloorProperties(exportData, layer) {
    exportData.levelsProperties.push({
      expressID: layer.id,
      type: 'IFCBUILDINGSTOREY',
      Name: { 'type': 1, 'value': layer.name },
      SceneHeight: layer.altitude / 100,
    });
  }

  getDefaultExportData() {
    return {
      levelsProperties: [],
      levelsRelationships: {},
      allTypes: {
        wall: 'IFCWALLSTANDARDCASE',
        area: 'IFCSLAB',
        window: 'IFCWINDOW',
        door: 'IFCDOOR',
        bookcase: 'IFCFURNISHINGELEMENT',
      },
      coordinationMatrix: { elements: [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1] },
      modelTypes: {},
      properties: {},
      fragmentMap: {},
    };
  }
}
